import{LitElement,html,css}from"https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";const skioStyles=css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0;
    border: 0;
    margin: 44px 0 24px;
  }

  @media (max-width: 768px) {
    .skio-plan-picker {
      gap: 10px;
    }
  }

  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    /* box-shadow: 0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.07); */
    border-radius: 0px;
    border-width: 0px;
    border-color: transparent;
    border-style: solid;
    transition: border-color 0.2s ease;

    font-size: 14px;
  }
  .skio-group-container--selected {
    border-color: #000;
  }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }

  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    /* padding: 10px; */
    overflow: hidden;
    text-transform: uppercase;
  }

  .skio-group-topline {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 14px;
    font-weight: 700;
  }

  .skio-radio__container {
    display: flex;
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    .skio-radio__container svg {
      width: 28px;
      height: 28px;
    }

    .skio-radio__container svg .skio-radio {
      r: 8;
    }
  }

  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }

  .skio-price {
    margin-left: auto;
    padding-right: 5px;
  }

  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1;
  }

  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }

  .skio-group-container:not(.skio-group-container--selected) .skio-group-topline,
  .skio-group-container:not(.skio-group-container--selected) .skio-frequency {
    color: #BEBEBE;
  }

  .skio-group-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .skio-save {
    /* color: #0fa573;
    border: 1px #0fa573 solid;
    padding: 0px 8px;
    border-radius: 20px; */
  }

  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    border: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 0px top 50%;
    background-size: 10px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    text-decoration: underline;
    text-decoration-thickness: 10%;
    text-transform: uppercase;

    max-width: 200px;

    max-width: fit-content;
    padding-right: 16px;

    font-family: "Neuzeit Grotesk", sans-serif;
    font-weight: 700;
  }

  .skio-group-container:not(.skio-group-container--selected) .skio-frequency {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23BEBEBE' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
  }

  .skio-frequency.skio-frequency--one {
    background-image: none;
  }

  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    justify-content: center;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: 0;
    font-style: normal;
    font-size: 14px;
    text-decoration: none;
    box-shadow: 0 0 #0000004d inset;
    width: 100%;
    color: #fff;
    background-color: #5f3ebc;
    border-radius: 5px;
    transition-duration: .3s;
    padding: 10px 32px;
    text-transform: uppercase;
    cursor: pointer;
    font-family: "Neuzeit Grotesk", sans-serif;
    transition: border-color 0.25s ease, background-color 0.25s ease, color 0.25s ease;

    border: solid 2px rgba(0,0,0,0);
  }
  button.add-to-cart:hover {
    background-color: rgba(0,0,0,0);
    color: #5f3ebc;
    border-color: #5f3ebc;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888;

    user-select: none;
    -webkit-user-select: none;
    margin-bottom: 20px;
    margin-top: 10px;
    order: 3;
  }

  .skio-details summary::-webkit-details-marker,
  .skio-details summary::marker {
    display: none;
    color: #fff !important;
  }

  .skio-details summary span {
    font-size: 0.9em;
    display: flex;
    padding: .5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    text-decoration: underline;

    margin-top: -40px;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .skio-details[open] > .skio-details--content {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
  }

  .skio-details--content {
    position: absolute;
    z-index: 1020;
    padding: 1em;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
  }

  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: flex-start;
    gap: .75em;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 0.9em;

    margin-top: 0;
    margin-bottom: 0;

    letter-spacing: 0;
    line-height: 1.5;

    color: var(--text-color);
  }

  .skio-details ul li small {
    font-size: 0.7em;
    color: var(--text-color-secondary);
  }

  .skio-details .skio-icon {
    display: flex;

    width: 2.25em;
    height: 2.25em;

    color: var(--text-color);
    background: #f8f8f8;
    border-radius: 100%;

    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .skio-details .skio-icon svg {
    width: 1.25em;
    height: 1.25em;

    color: inherit;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    text-decoration: underline;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;

    align-items: center;
    gap: 3px;
  }

`;export class SkioPlanPickerComponent extends LitElement{static properties={product:{type:Object},productHandle:{type:String},key:{type:String},formId:{type:String},needsFormId:{type:Boolean},subscriptionFirst:{type:Boolean},startSubscription:{type:Boolean},discountFormat:{type:String},currency:{type:String},language:{type:String},moneyFormatter:{},externalPriceSelector:{type:String},externalPriceSelectorWithCurrency:{type:String},selectedVariant:{type:Object},skioSellingPlanGroups:{},availableSellingPlanGroups:{},selectedSellingPlanGroup:{},selectedSellingPlan:{},defaultFrequency:{},showAddToCartButton:{type:Boolean}};static styles=skioStyles;constructor(){super(),this.product=null,this.selectedVariant=null,this.productHandle=null,this.purchaseOption="onetime",this.key=null,this.formId=null,this.needsFormId=!1,this.skioSellingPlanGroups=[],this.availableSellingPlanGroups=[],this.selectedSellingPlanGroup=null,this.selectedSellingPlan=null,this.startSubscription=!1,this.subscriptionFirst=!1,this.skioMainProduct=!0,this.discountFormat="percent",this.externalPriceSelector="[skio-external-price]",this.externalPriceSelectorWithCurrency="[skio-external-price-with-currency]",this.currency="USD",this.language="en-US",this.moneyFormatter=new Intl.NumberFormat(this.language,{style:"currency",currency:this.currency}),this.defaultFrequency=null,this.showAddToCartButton=!1}connectedCallback(){if(super.connectedCallback(),!1!==this.startSubscription&&(this.purchaseOption="subscription",null==this.selectedSellingPlan||null==this.selectedSellingPlan)){let e=this.availableSellingPlanGroups[0];this.selectSellingPlanGroup(e)}if(!this.product&&this.productHandle&&this.fetchProduct(this.productHandle),this.needsFormId&&null==this.formId){let e=document.querySelectorAll('form[action="/cart/add"]');if(e.length>0){let t;e.forEach((e=>{e.hasAttribute("skio-key")&&e.getAttribute("skio-key")==this.key&&(t=e)})),t||(t=e[0]),this.formId=t.id,this.requestUpdate()}}let e=this;document.addEventListener("variantChanged",(function(t){let i=t.detail.variantId,l=e.product.variants.find((e=>e.id==i));l?e.selectedVariant=l:e.log("Unable to find variant with id: ",i),e.requestUpdate()}));var t=[...document.querySelectorAll("details")];document.addEventListener("click",(function(e){t.some((t=>t.contains(e.target)))?t.forEach((t=>t.contains(e.target)?"":t.removeAttribute("open"))):t.forEach((e=>e.removeAttribute("open")))}))}render(){if(this.product&&this.selectedVariant&&0!=this.skioSellingPlanGroups.length)return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}">
        <input ${null!==this.formId?html`form="${this.formId}"`:""} name="selling_plan" type="hidden" value="${null!==this.selectedSellingPlan?this.selectedSellingPlan?.id:""}" />
        <input ${null!==this.formId?html`form="${this.formId}"`:""} name="properties[Discount]" type="hidden" value="${null!==this.selectedSellingPlan?this.discount(this.selectedSellingPlan).percent:""}"
          ?disabled="${null==this.selectedSellingPlan}" />

        <div class="skio-group-container ${0==this.product.requires_selling_plan?"skio-group-container--available":""} ${null==this.selectedSellingPlanGroup?"skio-group-container--selected":""} ${this.subscriptionFirst?"skio-onetime-second":""}" skio-group-container
          @click=${()=>this.selectSellingPlanGroup(null)} >

          <input id="skio-one-time-${this.key}" class="skio-group-input" name="skio-group-${this.key}" type="radio" value=""
            skio-one-time ?checked=${0==this.startSubscription&&0==this.product.requires_selling_plan}>
          <label class="skio-group-label" for="skio-one-time-${this.key}">
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#BEBEBE" stroke-width="1"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                </svg>
              </div>
              One-Time Purchase
              <div class="skio-price">
                <span skio-onetime-price>${this.moneyFormatter.format(this.selectedVariant.price/100)}</span>
              </div>
            </div>
          </label>
        </div>
        ${this.availableSellingPlanGroups?this.availableSellingPlanGroups.map(((e,t)=>html`
            <div class="skio-group-container skio-group-container--available ${this.selectedSellingPlanGroup==e?"skio-group-container--selected":""}" skio-group-container
              @click=${()=>this.selectSellingPlanGroup(e)}>
              <input id="skio-selling-plan-group-${t}-${this.key}" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${e.id}" skio-selling-plan-group="${e.id}" ?checked=${this.selectedSellingPlanGroup==e} >
              <label class="skio-group-label" for="skio-selling-plan-group-${t}-${this.key}">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="#BEBEBE" stroke-width="1"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    ${"Subscription"==e.name?"Subscribe":e.name}
                    ${"0%"!==this.discount(e.selected_selling_plan).percent?html`
                      <span class="skio-save">&nbsp;& Save <span skio-discount>${"percent"==this.discountFormat?this.discount(e.selected_selling_plan).percent:this.discount(e.selected_selling_plan).amount}</span> <span class="skio-discount">(${this.money(this.discount(e.selected_selling_plan).amount)}) &nbsp;</span> </span>
                    `:html``}
                    <select skio-selling-plans="${e.id}" class="skio-frequency"
                      @change=${t=>this.selectSellingPlan(t.target,e)}>
                      ${e?e.selling_plans.map((t=>html`
                        <option value="${t.id}" ?selected=${e.selected_selling_plan==t}>
                          ${e.name,`${t.name}`}
                        </option>
                      `)):""}
                    </select>
                  </div>
                  <div class="skio-price">
                    <span skio-subscription-price>${this.price(e.selected_selling_plan)}</span>
                  </div>
                </div>
                <!-- <div class="skio-group-content">
                  <select skio-selling-plans="${e.id}" class="skio-frequency"
                    @change=${t=>this.selectSellingPlan(t.target,e)}>
                    ${e?e.selling_plans.map((t=>html`
                      <option value="${t.id}" ?selected=${e.selected_selling_plan==t}>
                        ${e.name,`${t.name}`}
                      </option>
                      `)):""}
                  </select>
                </div> -->
              </label>
            </div>

          `)):""}

            <!-- <details class="skio-details">
              <summary>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowRepeat"><path d="M18 2l3 3-3 3"/><path d="M6 22l-3-3 3-3"/><path d="M21 5H10a7 7 0 0 0-7 7"/><path d="M3 19h11a7 7 0 0 0 7-7"/></svg>

                  How do subscriptions work?
                </span>
              </summary>
              <div class="skio-details--content">
                <ul>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <div class="skio-content">
                      <p>Get exclusive deals</p>
                      <small>Subscribe for unique discounts</small>
                    </div>
                  </li>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    </div>
                    <div class="skio-content">
                      <p>Edit your subscription anytime</p>
                      <small>Edit products, delivery schedule and more</small>
                    </div>
                  </li>
                  <li>
                    <div class="skio-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </div>

                    <div class="skio-content">
                      <p>No commitment</p>
                      <small>Easy to cancel if it’s not for you</small>
                    </div>
                  </li>
                </ul>
                <div class="skio-details--footer">
                  <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

                  <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
                    Powered by
                    <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5f3ebc">
                      <path d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z" fill="#5f3ebc"/>
                      <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="#5f3ebc"/>
                      <path d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z" fill="#5f3ebc"/>
                      <path d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z" fill="#5f3ebc"/>
                    </svg>
                  </a>

                </div>
              </div>
            </details> -->

            ${this.showAddToCartButton?html`
              <button @click=${()=>this.addToCart()} class="add-to-cart">Add to Cart</button>
            `:html``}

      </fieldset>`}updated=e=>{if(e.has("product")&&this.product&&(this.key=this.key?this.key:this.product.id,this.skioSellingPlanGroups=this.product.selling_plan_groups.filter((e=>"SKIO"===e.app_id)),this.skioSellingPlanGroups.forEach((e=>{e.selling_plans.sort((function(e,t){return parseInt(e.name.replace(/\D/g,""))<parseInt(t.name.replace(/\D/g,""))?-1:parseInt(e.name.replace(/\D/g,""))>parseInt(t.name.replace(/\D/g,""))?1:parseInt(e.name.replace(/\D/g,""))==parseInt(t.name.replace(/\D/g,""))?0:void 0}))}))),e.has("selectedVariant")&&this.selectedVariant){if(this.availableSellingPlanGroups=this.skioSellingPlanGroups.filter((e=>e.selling_plans.some((e=>this.selectedVariant.selling_plan_allocations.some((t=>t.selling_plan_id===e.id)))))),this.availableSellingPlanGroups?.length>0)if(this.availableSellingPlanGroups.forEach((e=>{if(this.defaultFrequency){let t=e.selling_plans.find((e=>e.name.toLowerCase().includes(this.defaultFrequency.toLowerCase())));e.selected_selling_plan=t||e.selling_plans[0]}else e.selected_selling_plan=e.selling_plans[0]})),!1!==this.startSubscription||1==this.product.requires_selling_plan||"subscription"==this.purchaseOption){if(null==this.selectedSellingPlan||null==this.selectedSellingPlan){let e=this.availableSellingPlanGroups[0];this.selectSellingPlanGroup(e)}let e=this.selectedSellingPlan.name,t=this.availableSellingPlanGroups.find((t=>t.selling_plans.find((t=>t.name==e)))),i=t.selling_plans.find((t=>t.name==e));e==i.name?(this.selectedSellingPlanGroup=t,this.selectedSellingPlan=i):(this.selectedSellingPlanGroup=this.availableSellingPlanGroups[0],this.selectedSellingPlan=this.availableSellingPlanGroups[0].selling_plans[0])}else this.selectedSellingPlan,this.selectedSellingPlanGroup=null;this.updateForm()}if(e.has("selectedSellingPlan")){document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach((e=>{e.innerHTML=this.price(this.selectedSellingPlan)})),document.querySelectorAll(`[skio-onetime-content][skio-key="${this.key}"]`).forEach((e=>{null!==this.selectedSellingPlan?e.style.display="none":e.style.removeProperty("display")})),document.querySelectorAll(`[skio-subscription-content][skio-key="${this.key}"]`).forEach((e=>{null==this.selectedSellingPlan?e.style.display="none":e.style.removeProperty("display")}));const e=new CustomEvent("skio::update-selling-plan",{bubbles:!0,composed:!0,detail:{sellingPlan:this.selectedSellingPlan,key:this.key}});this.dispatchEvent(e),this.updateForm(),this.updateExternalPrice()}e.has("formId")&&this.updateForm()};log=(...e)=>{e.unshift("%c[skio]","color: #8770f2;"),console.log.apply(console,e)};error=(...e)=>{e.unshift("%c [skio]","color: #ff0000"),console.error.apply(console,e)};updateExternalPrice(){document.querySelectorAll(this.externalPriceSelector).forEach((e=>{this.selectedSellingPlan?e.innerHTML=this.price(this.selectedSellingPlan):e.innerHTML=this.money(this.selectedVariant.price)})),document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((e=>{this.selectedSellingPlan?e.innerHTML=this.price(this.selectedSellingPlan)+" "+this.currency:e.innerHTML=this.money(this.selectedVariant.price)+" "+this.currency}))}selectSellingPlanGroup(e){this.selectedSellingPlanGroup=e,this.selectedSellingPlan=e?.selected_selling_plan,this.purchaseOption=e?"subscription":"onetime",this.updateForm()}selectSellingPlan(e,t){let i=t.selling_plans.find((t=>t.id==e.value));i?(t.selected_selling_plan=i,this.selectedSellingPlanGroup=t,this.selectedSellingPlan=i):this.log("Error: couldn't find selling plan with id "+e.value+" for variant "+this.selectedVariant.id+" from product "+this.product.id+" : "+this.product.handle)}money(e){return this.moneyFormatter.format(e/100)}discount(e){if(!e)return{percent:"0%",amount:0};if(e.name.includes("prepaid")){let t=e.options[0].value;let i=parseInt(t.match(/\d+/g).join(""));const l=e.price_adjustments[0],s={percent:"0%",amount:0},n=this.selectedVariant.price*i;switch(l.value_type){case"percentage":s.percent=`${l.value}%`,s.amount=Math.round(n*l.value/100);break;case"fixed_amount":s.percent=`${Math.round(1*l.value/n*100)}%`,s.amount=n-l.value;break;case"price":s.percent=`${Math.round(1*(n-l.value)/n*100)}%`,s.amount=n-l.value}return s}{const t=e.price_adjustments[0],i={percent:"0%",amount:0},l=this.selectedVariant.price;switch(t.value_type){case"percentage":i.percent=`${t.value}%`,i.amount=Math.round(l*t.value/100);break;case"fixed_amount":i.percent=`${Math.round(1*t.value/l*100)}%`,i.amount=t.value;break;case"price":i.percent=`${Math.round(1*(l-t.value)/l*100)}%`,i.amount=l-t.value}return i}}price(e,t=!0){if(e.name.includes("prepaid")){let i=e.options[0].value;let l=parseInt(i.match(/\d+/g).join(""));return t?this.money(this.selectedVariant.price*l-this.discount(e).amount):this.selectedVariant.price*l-this.discount(e).amount}return t?this.money(this.selectedVariant.price-this.discount(e).amount):this.selectedVariant.price-this.discount(e).amount}updateForm(){if(this.formId){let e=document.querySelector(`#${this.formId}`);if(e){let t=e.querySelector('[name="selling_plan"]');t?(t.value=void 0!==this.selectedSellingPlan?.id?this.selectedSellingPlan?.id:null,t.disabled=void 0===this.selectedSellingPlan?.id):(t=document.createElement("input"),t.type="hidden",t.name="selling_plan",t.value=void 0!==this.selectedSellingPlan?.id?this.selectedSellingPlan?.id:null,t.disabled=void 0===this.selectedSellingPlan?.id,e.append(t));let i=e.querySelector('[name="properties[Discount]"]');i?(i.value=void 0!==this.selectedSellingPlan?.id?this.discount(this.selectedSellingPlan).percent:null,i.disabled=void 0===this.selectedSellingPlan?.id):(i=document.createElement("input"),i.type="hidden",i.name="properties[Discount]",i.value=void 0!==this.selectedSellingPlan?.id?this.discount(this.selectedSellingPlan).percent:null,i.disabled=void 0===this.selectedSellingPlan?.id,e.append(i))}else console.log(`Skio error: form ID is ${this.formId}, but no form with that ID was found.`)}}addToCart(e=1){const t=[{id:this.selectedVariant.id,quantity:e,...this.selectedSellingPlan&&{selling_plan:this.selectedSellingPlan?.id}}];fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:t})}).then((e=>e.json())).then((e=>{this.log("SKIO added item to cart: ",e);const t=new CustomEvent("skio::added-to-cart",{bubbles:!0,composed:!0,detail:{response:e,key:this.key}});this.dispatchEvent(t)})).catch((e=>{this.error(`SKIO ${this.key} error adding item to cart: `,e)}))}fetchProduct=e=>fetch(`/products/${e}.js`).then((e=>e.json())).then((e=>(this.product=e,this.selectedVariant=e.variants[0],e)))}customElements.define("skio-plan-picker",SkioPlanPickerComponent);